'use client';

import type { FC } from 'react';
import { BottomSheet } from '../../../ui';
import { useLocalTranslation } from '../../../../hooks/useLocalTranslation';
import translations from '../RushMid.translations';
import { HowToPlayContent } from './HowToPlayContent';

interface HowToPlaySheetProps {
  isOpen: boolean;
  onClose: () => void;
}

/** Bottom sheet with the full "how to play" rules — opened from the lobby "?" button. */
export const HowToPlaySheet: FC<HowToPlaySheetProps> = ({ isOpen, onClose }) => {
  const { t } = useLocalTranslation(translations);
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('howtoTitle')}>
      <HowToPlayContent />
    </BottomSheet>
  );
};
